module.exports = __webpack_public_path__ + "static/img/PNG顶图-1(2).c9e92de.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/PNG顶图-1(2).png
// module id = Hh2E
// module chunks = 1